import restAPI from "../http-common";
import session from "./session";

class GuestCountApi {
	setOpenClosedDays({ outletId, openClosedDays }) {
		return restAPI({
			method: "PUT",
			url: "/set-open-closed-days",
			data: {
				outlet_id: outletId,
				open_closed_days: openClosedDays,
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setExceptionalClosedDays({ outletId, exceptionalClosedDays }) {
		return restAPI({
			method: "PUT",
			url: "/set-exceptional-closed-days",
			data: {
				outlet_id: outletId,
				exceptional_closed_days: exceptionalClosedDays,
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}
}

export const GuestCountService = new GuestCountApi();
